import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import StatusInfoCard from "./StatusInfoCard";

const MainOperationCard = ({ info }) => {
    const { t } = useTranslation();
    if (!info) return null;
    
    const opStatusName = (info.latestEquipmentOp?.opStatus && info.latestEquipmentOp?.opStatus === 'ACTIVE') ? t('message.common.text.active') : t('message.common.text.stop');
    const getFontSize = (text) => {
        if (text.length <= 2) return 26;
        if (text.length <= 4) return 20;
        if (text.length <= 6) return 17;
        return 14;
    };
    
    return (
    <StatusInfoCard title={t('message.common.subtitle.main.operation.info')} cardType="charts_circle">
        <Box
            sx={{
                borderRadius: 2,
                p: 1.5,
                boxSizing: "border-box",
            }}
        >
            <svg width="100" height="100" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="45" fill={`${(info.latestEquipmentOp?.opStatus && info.latestEquipmentOp?.opStatus === 'ACTIVE') ? "#02db02" : "#b2b2b2"}`} />
                <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="white" fontSize={getFontSize(opStatusName)}>
                    {opStatusName}
                </text>
            </svg>
            {/* <Box
                sx={{
                    borderRadius: "50%",
                    backgroundColor: `${(info.latestEquipmentOp?.opStatus && info.latestEquipmentOp?.opStatus === 'ACTIVE') ? "#007aa7" : "#777"}`,
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.25)", // 그림자
                }}
            >
                {(info.latestEquipmentOp?.opStatus && info.latestEquipmentOp?.opStatus === 'ACTIVE') ? t('message.common.text.active') : t('message.common.text.stop')}
            </Box> */}
        </Box>
    </StatusInfoCard>
    );
}

export default MainOperationCard;